export default "__VITE_ASSET__3eaa877c__"